import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import store from '@/store/store';
import { changeTenantInfo } from '@/store/common';
import { getTenantInfo as api } from 'src/common/api/system';

/**
 * 获取当前租户信息
 * @description
 * @return {*}
 * @demo
  const {
    getTenantInfo,
    tenantInfo,
  } = useTenantInfo();
 */
export const useTenantInfo = ({ immediate }: {
  /** 是否立即调用接口获取一次 */
  immediate: boolean;
} = { immediate: true }) => {

  /** 获取当前租户信息 */
  const tenantInfo = useSelector((state: any) => state.common.tenantInfo) || null;

  /** 更新当前租户信息 */
  const updateTenantCheckInfo = useCallback((data) => {
    store.dispatch(changeTenantInfo(data));
  }, []);

  /** 获取当前租户信息
   * @description
   * @param {*} force 强制更新数据
   * @return {*}
   * @demo
   */
  const getTenantInfo = useCallback(async (force?: boolean): Promise<any> => {
    // 如果已经有缓存，直接返回
    if (tenantInfo && Object.keys(tenantInfo).length && !force) {
      return tenantInfo;
    }

    try {
      const res = await api().catch(() => {});
      const tenantInfo = res || {};

      // 更新当前租户信息
      updateTenantCheckInfo(tenantInfo);
      return tenantInfo;
    } catch (error) {
      console.error('获取当前租户的信息失败:', error);
      throw error;
    }
  }, [tenantInfo, updateTenantCheckInfo]);

  useEffect(() => {
    immediate && getTenantInfo();
  }, []);

  return {
    // actions
    /** 获取当前租户信息 */
    getTenantInfo,

    // state
    /** 当前租户信息 */
    tenantInfo,
  };
};
